<app-color-step
  class="ion-page"
  [(selectedColor)]="color"
  (selectedColorChange)="onNext()">
</app-color-step>
